import { SWAN_STYLE_KEYS } from '@vp/product-options-ui';
import { SWAN_STYLE_KEY_MAP } from '@vp/swan';
export const SpecsTemplatesSwanStyleKeys = [
  SWAN_STYLE_KEY_MAP.core,
  SWAN_STYLE_KEY_MAP.alertBox,
  SWAN_STYLE_KEY_MAP.spinner,
  SWAN_STYLE_KEY_MAP.button,
  SWAN_STYLE_KEY_MAP.table,
  SWAN_STYLE_KEY_MAP.modalDialog,
  ...SWAN_STYLE_KEYS,
];
